MOVE.PropertyRecords = (function (MOVE) {
  var init = function () {
  };

  MOVE.PropertyRecords =
  {
    init: init
  };

  return MOVE.PropertyRecords;
})(MOVE || {});



// WEBPACK FOOTER //
// ./property_records/page.js